import { Link } from "gatsby"
import * as React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faGithub,
  faXTwitter,
  faYoutube,
  faBluesky
} from "@fortawesome/free-brands-svg-icons"
import Logo from "./Logo"
import { NewsletterContent } from "../common/Newsletter"

interface Props {
  hideNewsletter?: boolean
}

const Footer = ({ hideNewsletter }: Props) => {
  return (
    <>
      <footer className="footer has-background-white">
        <div className="content has-text-left">
          <div className="container mb-6 links">
            <div className="columns is-desktop">
              <div className="column is-7-desktop is-10-tablet">
                <div className="columns is-multiline is-mobile">
                  <div className="column">
                    <div className="item has-text-weight-bold">
                      <Link to="/why-spring">Why Spring</Link>
                    </div>
                    <div className="item footer-link">
                      <Link to="/microservices">Microservices</Link>
                    </div>
                    <div className="item footer-link">
                      <Link to="/reactive">Reactive</Link>
                    </div>
                    <div className="item footer-link">
                      <Link to="/event-driven">Event Driven</Link>
                    </div>
                    <div className="item footer-link">
                      <Link to="/cloud">Cloud</Link>
                    </div>
                    <div className="item footer-link">
                      <Link to="/web-applications">Web Applications</Link>
                    </div>
                    <div className="item footer-link">
                      <Link to="/serverless">Serverless</Link>
                    </div>
                    <div className="item footer-link">
                      <Link to="/batch">Batch</Link>
                    </div>
                  </div>
                  <div className="column">
                    <div className="item has-text-weight-bold">
                      <Link to="/learn">Learn</Link>
                    </div>
                    <div className="item footer-link">
                      <Link to="/quickstart">Quickstart</Link>
                    </div>
                    <div className="item footer-link">
                      <Link to="/guides">Guides</Link>
                    </div>
                    <div className="item footer-link">
                      <Link to="/blog">Blog</Link>
                    </div>
                    <div className="item pt-4 has-text-weight-bold">
                      <Link to="/community">Community</Link>
                    </div>
                    <div className="item footer-link">
                      <Link to="/events">Events</Link>
                    </div>
                    <div className="item footer-link">
                      <Link to="/authors">Authors</Link>
                    </div>
                  </div>
                  <div className="column">
                    <div className="item footer-link">
                      <a href="https://enterprise.spring.io">
                        Tanzu Spring
                      </a>
                    </div>
                    <div className="item footer-link">
                      <a href="https://spring.academy/">
                        Spring Academy
                      </a>
                    </div>
                    <div className="item footer-link">
                      <Link to="/security">Spring Advisories</Link>
                    </div>
                  </div>
                  <div className="column">
                    <div className="item has-text-weight-bold">
                      <Link to="/projects">Projects</Link>
                    </div>
                    <div className="item has-text-weight-bold mt-4">
                      <Link to="/thank-you">Thank You</Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="column is-5-desktop is-10-mobile is-10-tablet">
                {!hideNewsletter && (
                  <div className="newsletter">
                    <div className="mt-4">
                      <div className="has-big-border px-5 py-5">
                        <NewsletterContent />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="container more">
            <div className="columns">
              <div className="column">
                <p>
                  <Logo />
                </p>
                <p className="has-text-grey6">
                  Copyright © 2005 - {new Date().getFullYear()} Broadcom. All
                  Rights Reserved. The term "Broadcom" refers to Broadcom Inc.
                  and/or its subsidiaries. <br />
                  <a
                    href="https://www.broadcom.com/company/legal/terms-of-use"
                    className="footer-link"
                  >
                    Terms of Use
                  </a>{" "}
                  •{" "}
                  <a
                    href="https://www.broadcom.com/company/legal/privacy"
                    className="footer-link"
                  >
                    Privacy
                  </a>{" "}
                  •{" "}
                  <Link className="footer-link" to={"/trademarks"}>
                    Trademark Guidelines
                  </Link>{" "}
                </p>
                <p className="has-text-grey-light">
                  Apache®, Apache Tomcat®, Apache Kafka®, Apache Cassandra™,
                  and Apache Geode™ are trademarks or registered trademarks of
                  the Apache Software Foundation in the United States and/or
                  other countries. Java™, Java™ SE, Java™ EE, and OpenJDK™
                  are trademarks of Oracle and/or its affiliates. Kubernetes®
                  is a registered trademark of the Linux Foundation in the
                  United States and other countries. Linux® is the registered
                  trademark of Linus Torvalds in the United States and other
                  countries. Windows® and Microsoft® Azure are registered
                  trademarks of Microsoft Corporation. “AWS” and “Amazon Web
                  Services” are trademarks or registered trademarks of
                  Amazon.com Inc. or its affiliates. All other trademarks and
                  copyrights are property of their respective owners and are
                  only mentioned for informative purposes. Other names may be
                  trademarks of their respective owners.
                </p>
              </div>
              <div className="social-links column is-3">
                <a
                  aria-label="Youtube"
                  href="https://www.youtube.com/user/SpringSourceDev"
                  className="button is-black is-rounded"
                >
                  <FontAwesomeIcon icon={faYoutube} />
                </a>
                <a
                  aria-label="Github"
                  href="https://github.com/spring-projects"
                  className="button is-black is-rounded"
                >
                  <FontAwesomeIcon icon={faGithub} />
                </a>
                <a
                  aria-label="X"
                  href="https://x.com/springcentral"
                  className="button is-black is-rounded"
                >
                  <FontAwesomeIcon icon={faXTwitter} />
                </a>
                <a
                    aria-label="BlueSky"
                    href="https://bsky.app/profile/spring.io"
                    className="button is-black is-rounded"
                >
                  <FontAwesomeIcon icon={faBluesky} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}

export default Footer
